/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { StorageModule } from "@vlinder-web/storage-module-react";
import { ProcessQResponseMessage } from "../../../messages";

export const formatQueueHeaderData = async (context: any, event: any) => {
  return new Promise(async (resolve, reject) => {
    const message: ProcessQResponseMessage = context?.message;
    const storageService = StorageModule.getInstance();
    try {
      const distCenterData = storageService.get("distCenterData", "local");
      if (distCenterData?.header?.band?.name) {
        message.header.band = distCenterData?.header?.band?.name;
      }
      if (distCenterData?.header?.counter?.name) {
        message.header.counter = String(distCenterData?.header?.counter?.name);
      }
      if (distCenterData?.header?.distCenter?.name) {
        message.header.distCenter = distCenterData?.header?.distCenter?.name;
      }
      if (distCenterData?.paymentCounter) {
        console.log(`o?. :`, distCenterData?.paymentCounter);
        message.distCounterMid = distCenterData?.paymentCounter;
      }
      return resolve(true);
    } catch (err: any) {
      console.log(`error in formatQueueHeaderData error=${err?.message}`);
      return reject(err?.message);
    }
  });
};
